import React from 'react';

import EditIcon from '@mui/icons-material/Edit';
import WarningIcon from '@mui/icons-material/Warning';

export default function EditStatusCellRenderer(props: any) {
    const { data } = props;
    
    if (!data) return null;
    
    if (data.errors && Object.keys(data.errors).length > 0) {
      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <WarningIcon style={{ color: '#f44336' }} />
        </div>
      );
    }
    
    if (data.isEdited && data.editedFields.size > 0) {
      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <EditIcon style={{ color: '#2196f3' }} />
        </div>
      );
    }
    
    return null;
  }